export const initState = {
  selected: [],
  opened: [],
  ids: [],
  data: [],
  fetch: false,
  searchData: [],
  searchIds: [],
  searchFetch: false,
  prevPath: '',
  catalog: null,
  detailParams: {},
  creditAprovedData: [],
  carInstanceData: {},
  showFinancePopup: false,
  showCreditRefusalPopup: false,
  adminManualFinanceParams: {
    bankId: null,
    dealId: null,
    dealerName: null,
  },
  prepareApplicationForClosingData: { applicationId: null, lastStateId: null },
  resetApplicationsList: [],
};
